<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="less" scoped>
    .login-loading {
        text-align: center;
        font-size: 16px;
        padding: 30px;
        font-weight: bold;
    }
</style>

<template>
    <div class="container">
        <p class="login-loading">跳转中，请等待...</p>
    </div>
</template>

<script>
  // token?data=%7B"code"%3A"0","data"%3A%7B"token"%3A"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1aWQiOiIxNDY0OEUzRkFFNEQ0QjAxQkY1NTgyMzQ0MzRGM0Q4RSJ9.U8lSjj_DqmrHmlbb42rYP92MOhy8P1htDOr1h6776fs","userId"%3A27,"userUuid"%3A"14648E3FAE4D4B01BF558234434F3D8E"%7D,"msg"%3A""%7D
  export default {
    created () {
      let data = this.$route.query.data
      data = unescape(data)
      // 应该是这样一个数据结构
      // {
      //    "code":"0",
      //    "data":{
      //        "token":"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1aWQiOiIxNDY0OEUzRkFFNEQ0QjAxQkY1NTgyMzQ0MzRGM0Q4RSJ9.U8lSjj_DqmrHmlbb42rYP92MOhy8P1htDOr1h6776fs",
      //        "userId":27,
      //        "userUuid":"14648E3FAE4D4B01BF558234434F3D8E"
      //    },
      //    "msg":""
      // }
      console.log(data)
      if (typeof data === 'string') {
        data = JSON.parse(data)
      }
      console.log(data)
      if (data.code === '0') {
        // 成功 获取用户信息后跳转
        window.localStorage['token'] = data.data.token
        this.getUserInfo()
      } else {
        // 失败 给出错误信息 重回登录页面
        this.$router.replace({
          name: 'login',
          params: {
            errMsg: data.msg
          }
        })
      }
    },
    methods: {
      getUserInfo () {
        this.$store.dispatch('getUserInfo').then((res) => {
          this.$router.replace({
            path: '/'
          })
        }, (err) => {
          console.log('获取用户信息失败')
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/token.vue